export const tr = {
    error: 'Hata oluştu, lütfen az sonra tekrar deneyin'
};
